import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { UtilsModule } from '../../utils/utils.module';
import {NzMessageService} from 'ng-zorro-antd/message';
import {DatePipe} from '@angular/common';
@Component({
  selector: 'nf-scheduler',
  templateUrl: './scheduler.component.html',
  styleUrls: ['./scheduler.component.css'],
  providers: [UtilsModule, DatePipe]
})
export class SchedulerComponent implements OnInit {
  schedulerRadioValue = 'daily'; // 定时组件默认标签页
  schedulerDailyOccurrences = '1'; // 定时组件日默认值
  schedulerDailyTimeValue = new Date(); // 定时组件时间默认值
  schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 天的 ' +
    this.utilsModule.formatTimeByGeneral(this.schedulerDailyTimeValue); // 定时组件每日生成文本
  schedulerDateType = 'days';
  schedulerDateTypeText = '自然日';
  schedulerWeeklyOccurrences = '1'; // 定时组件周默认值
  schedulerWeeklyTimeValue = new Date(); // 定时组件时间默认值
  schedulerWeeklyMergeText = '';
  schedulerWeeklyList: Array<any> = [
    {id: 1, label: '周一', select: false},
    {id: 2, label: '周二', select: false},
    {id: 3, label: '周三', select: false},
    {id: 4, label: '周四', select: false},
    {id: 5, label: '周五', select: false},
    {id: 6, label: '周六', select: false},
    {id: 7, label: '周日', select: false}
  ];
  schedulerWeeklyArray: Array<any> = [];
  schedulerMonthlyOccurrences = '1'; // 定时组件月默认值
  schedulerMonthlyTimeValue = new Date(); // 定时组件时间默认值
  schedulerMonthlyMergeText = '';
  schedulerMonthlyList: Array<any> = [];
  schedulerMonthlyArray: Array<any> = [];
  dateTypes = [
    {label: '自然日', value: 'days'},
    {label: '工作日', value: 'workdays'}
  ];
  // 时间区间配置
  hourStart = new Date();
  hourEnd = new Date();
  minutesHourStart = '';
  minutesHourEnd = '';
  minutesOccurrences = '1';
  minutesDateType = 'days';
  minutesInterval = '1';
  minutesDescription = '';
  @Input() dateTypeEnable = false;
  @Input('nfData') set ChangeData(data: any) {
    if (data && JSON.stringify(data) !== '{}') {
      this.schedulerRadioValue = data.type;
      this.schedulerDateType = data.dateType;
      this.schedulerDateTypeChange();
      if (this.schedulerRadioValue === 'daily') {
        this.schedulerDailyOccurrences = data.occurrences;
        this.schedulerDailyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
        this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 天的 ' + data.time;
      } else if (this.schedulerRadioValue === 'weekly') {
        if (data.days && data.days.length) {
          for (const weekDay of this.schedulerWeeklyList) {
            if (data.days.includes(weekDay.id)) {
              weekDay.select = true;
            }
          }
        }
        this.schedulerWeeklyMerge();
        this.schedulerWeeklyOccurrences = data.occurrences;
        this.schedulerWeeklyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
      } else if (this.schedulerRadioValue === 'monthly') {
        setTimeout(() => {
          if (data.days && data.days.length) {
            for (const day of this.schedulerMonthlyList) {
              if (data.days.includes(day.id)) {
                day.select = true;
              }
            }
          }
          this.schedulerMonthlyMerge();
        }, 200);
        this.schedulerMonthlyOccurrences = data.occurrences;
        this.schedulerMonthlyTimeValue = new Date(this.utilsModule.formatDateByGeneral(new Date()) + ' ' + data.time);
      } else if (this.schedulerRadioValue === 'minutes') {
        this.minutesOccurrences = data.occurrences;
        if (data.hourStart) {
          this.hourStart.setHours(Number(data.hourStart));
        }
        if (data.hourEnd) {
          this.hourEnd.setHours(Number(data.hourEnd));
        }
        this.minutesInterval = data.minutesInterval;
        this.minutesChange();
      }
    }
  }
  @Output() nfDataChange: EventEmitter<any> = new EventEmitter<any>();
  constructor(
    private utilsModule: UtilsModule,
    private message: NzMessageService,
    private datePipe: DatePipe
  ) { }

  ngOnInit() {
    // 定时初始化
    this.schedulerInit();
    if (this.dateTypeEnable) {
      this.schedulerDailyDisplayText = '每 ' + this.schedulerDailyOccurrences + ' 个 ' + this.schedulerDateTypeText + ' 的 ' +
        this.utilsModule.formatTimeByGeneral(this.schedulerDailyTimeValue);
    }
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'minutes') {
      this.minutesChange();
    }
  }
  schedulerInit() {
    for (let i = 1; i < 32; i++) {
      const obj = {
        'id': i,
        'label': i,
        'select': false
      };
      this.schedulerMonthlyList.push(obj);
    }
  }
  // 定时任务组件-radio切换
  schedulerRadioChange(event) {
    if (this.schedulerRadioValue === 'weekly') {
      this.schedulerWeeklyMerge();
    }
    if (this.schedulerRadioValue === 'monthly') {
      this.schedulerMonthlyMerge();
    }
    if (this.schedulerRadioValue === 'minutes') {
      this.minutesChange();
    }
  }
  // 日期类型选择回调
  schedulerDateTypeChange() {
    for (const dateType of this.dateTypes) {
      if (dateType.value === this.schedulerDateType) {
        this.schedulerDateTypeText = dateType.label;
        break;
      }
    }
  }
  // 定时任务组件-每周选择回调
  schedulerWeeklyTextChange(event) {
    event.select = !event.select;
    this.schedulerWeeklyMerge();
  }
  // 选中的周文字合并
  schedulerWeeklyMerge() {
    this.schedulerWeeklyArray = [];
    const weeklyText = [];
    this.schedulerWeeklyMergeText = '';
    this.schedulerWeeklyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerWeeklyArray.push(item.id);
        weeklyText.push(item.label);
      }
    });
    this.schedulerWeeklyMergeText = weeklyText.join('，');
  }
  schedulerMonthlyTextChange(event) {
    event.select = !event.select;
    this.schedulerMonthlyMerge();
  }

  // 选中的月文字合并
  schedulerMonthlyMerge() {
    this.schedulerMonthlyArray = [];
    const labelData = [];
    this.schedulerMonthlyList.forEach((item, index) => {
      if (item.select) {
        this.schedulerMonthlyArray.push(item.id);
        labelData.push(item.id + '号');
      }
    });
    this.schedulerMonthlyMergeText = labelData.join('，');
  }
  // 处理时间区间
  minutesChange() {
    this.minutesDescription = '每' + this.minutesOccurrences + ' 个 ' + this.getSelectTitle(this.dateTypes, this.schedulerDateType) + ' 的 ' + this.utilsModule.formatHoursByGeneral(this.hourStart) + '时至' + this.utilsModule.formatHoursByGeneral(this.hourEnd) + '时 每隔' + this.minutesInterval + '分钟';
  }
  // 获取下拉选项的表述
  getSelectTitle(target: Array<any>, value): string {
    if (target && target.length > 0) {
      for (let item of target) {
        if (item.value === value) {
          return item.label;
        }
      }
      return '';
    } else {
      return '';
    }
  }
  // 提交定时
  schedulerOnSubmit() {
    let schedulerConfig = {};
    let schedulerConfigText = '';
    if (this.schedulerRadioValue === 'daily') {
      schedulerConfig = {
        'type': 'daily',
        'occurrences': this.schedulerDailyOccurrences,
        'time': this.datePipe.transform(this.schedulerDailyTimeValue, 'HH:mm:ss')
      };
      schedulerConfigText = '每 ' + this.schedulerDailyOccurrences + (this.dateTypeEnable ?
        ' 个 ' + this.schedulerDateTypeText + ' 的 ' : ' 天的 ') + schedulerConfig['time'];
    } else if (this.schedulerRadioValue === 'weekly') {
      if (this.schedulerWeeklyArray.length <= 0) {
        this.message.warning('请选择每周的至少一天！');
        return;
      }
      schedulerConfig = {
        'type': 'weekly',
        'occurrences': this.schedulerWeeklyOccurrences,
        'days': this.schedulerWeeklyArray,
        'time': this.datePipe.transform(this.schedulerWeeklyTimeValue, 'HH:mm:ss')
      };
      schedulerConfigText = '每 ' + this.schedulerWeeklyOccurrences + (this.dateTypeEnable ?
        ' 周 属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 周的 ') + this.schedulerWeeklyMergeText + ' 的 ' + schedulerConfig['time'];
    } else if (this.schedulerRadioValue === 'monthly') {
      if (this.schedulerMonthlyArray.length <= 0) {
        this.message.warning('请选择每月的至少一天！');
        return;
      }
      schedulerConfig = {
        'type': 'monthly',
        'occurrences': this.schedulerMonthlyOccurrences,
        'days': this.schedulerMonthlyArray,
        'time': this.datePipe.transform(this.schedulerMonthlyTimeValue, 'HH:mm:ss')
      };
      schedulerConfigText = '每 ' + this.schedulerMonthlyOccurrences + (this.dateTypeEnable ?
        ' 月 属于 ' + this.schedulerDateTypeText + ' 的 ' : ' 月的 ') + this.schedulerMonthlyMergeText + ' 的 ' + schedulerConfig['time'];
    } else if (this.schedulerRadioValue === 'minutes') {
      this.minutesHourStart = this.utilsModule.formatHoursByGeneral(this.hourStart);
      this.minutesHourEnd = this.utilsModule.formatHoursByGeneral(this.hourEnd);
      schedulerConfig = {
        'type': 'minutes',
        'occurrences': this.minutesOccurrences,
        'hourStart': this.minutesHourStart,
        'hourEnd': this.minutesHourEnd,
        'minutesInterval': this.minutesInterval
      };
      schedulerConfigText = this.minutesDescription = '每' + this.minutesOccurrences + ' 个 ' + this.getSelectTitle(this.dateTypes, this.minutesDateType) + ' 的 ' + this.utilsModule.formatHoursByGeneral(this.hourStart) + '时至' + this.utilsModule.formatHoursByGeneral(this.hourEnd) + '时 每隔' + this.minutesInterval + '分钟';
    }
    schedulerConfig['dateType'] = this.schedulerDateType;
    const schedulerConfigData = {
      'config': schedulerConfig,
      'text': schedulerConfigText
    };
    this.nfDataChange.emit(schedulerConfigData);
  }
}
